//#region src/ContextMenu/utils.ts
function isTouchOrPen(event) {
	return event.pointerType !== "mouse";
}

//#endregion
export { isTouchOrPen };
//# sourceMappingURL=utils.js.map